<script lang="ts">
    import { SettingFormInputDefinition } from 'header/types';

    import { createEventDispatcher } from 'svelte';
    import SettingsField from './SettingsField.svelte';

    interface Props {
        settingDefinitions: SettingFormInputDefinition[];
        nolabel: boolean;
    }

    let { settingDefinitions, nolabel }: Props = $props();

    const dispatch = createEventDispatcher();
    const handleSettingChange = (event: CustomEvent) => {
        dispatch('change', event.detail);
    };
</script>

<div class="group" data-testid="setting-field-group">
    {#each settingDefinitions as field (field.key)}
        <div class="group__row">
            <SettingsField {field} {nolabel} on:change={handleSettingChange} />
        </div>
    {/each}
</div>

<style lang="scss" scoped>
    .group {
        min-width: 300px;
        &__row:not(:first-child) {
            margin-top: 1rem;
        }
    }
</style>
